module.exports = __webpack_public_path__ + "images/0bdd0fe25b5e1bcaab42df2df9b1a667989a838af515ceab5a43ab333b101a13.svg";